export const config = require('./config.json');
// https://pupbiz-backend-2krvczersq-uc.a.run.app
